import { Component, OnInit, OnDestroy } from '@angular/core';
import { IoService } from '../services/io.service';
import { Subscription} from 'rxjs';

@Component({
  selector: 'app-dashboard',
  templateUrl: './Dashboard.component.html',
  styleUrls: ['./Dashboard.component.css']
})
export class DashboardComponent implements OnInit, OnDestroy {
  counter: number;
  devices: string;
  subHeartbeat: Subscription;

  constructor(private ioService: IoService) { }

  ngOnInit() {
    /*
    this.subHeartbeat = this.ioService.getHeartbeat().subscribe(v => {
      this.counter = v.counter;
    });
    */

    this.ioService.getDevices(v => {
      this.devices = JSON.stringify(v);
    });

  }

  ngOnDestroy(): void {
    // if (this.subHeartbeat) { this.subHeartbeat.unsubscribe(); }
    this.ioService.removeListeners();
    console.log('unsubscribing');
  }

}
